export default __webpack_public_path__ + "static/media/Labirynth-08.3c7c55c3.svg";